// "Your perk choices": the Study Hall badge, name color, flair and credits. Used by
// the Supporter page and Settings > Supporter. Saves each change on its own.
import { NAME_COLORS, FLAIRS } from "../shared/name-colors.js";
import { T } from "./copy.js";

let seq = 0;
const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };

function switchRow(label, help, on, onChange) {
	const id = "sp-sw-" + ++seq;
	const row = el("div", "rv-row");
	const txt = el("div", "rv-row-text");
	const l = el("div", "rv-row-label", label);
	l.id = id;
	txt.append(l);
	if (help) { const d = el("div", "rv-row-desc", help); d.id = id + "-d"; txt.append(d); }
	const b = el("button", "rv-switch");
	b.type = "button";
	b.setAttribute("role", "switch");
	b.setAttribute("aria-labelledby", id);
	if (help) b.setAttribute("aria-describedby", id + "-d");
	const set = (v) => { b.dataset.on = v ? "1" : "0"; b.setAttribute("aria-checked", String(!!v)); };
	set(on);
	b.addEventListener("click", async () => { const v = b.dataset.on !== "1"; set(v); if (!(await onChange(v))) set(!v); });
	const c = el("div", "rv-row-control");
	c.append(b);
	row.append(txt, c);
	return row;
}

// state: the /account/supporter answer. save(patch) -> Promise<boolean>. say(text) announces.
export function renderPrefs(root, state, save, say) {
	root.textContent = "";
	const p = state.prefs || {};
	const put = async (patch) => { const ok = await save(patch); if (ok) say(T.saved); return ok; };
	root.append(switchRow(T.showBadge, T.showBadgeHelp, p.showBadge, (v) => put({ showBadge: v })));

	// Name color: a radio group, each option a dot plus its name, so color is never the only cue.
	const colorRow = el("div", "rv-row rv-row-block");
	const fs = el("fieldset", "sp-colors");
	const lg = el("legend", "rv-row-label", T.nameColor);
	fs.append(lg);
	const group = "sp-color-" + ++seq;
	const opts = [{ i: -1, label: T.noColor }].concat(NAME_COLORS.map((c, i) => ({ i, label: c.label, c })));
	for (const o of opts) {
		const lab = el("label", "sp-color");
		const r = document.createElement("input");
		r.type = "radio";
		r.name = group;
		r.value = String(o.i);
		r.checked = (p.nameColor == null ? -1 : p.nameColor) === o.i;
		r.addEventListener("change", () => { if (r.checked) put({ nameColor: o.i }); });
		const dot = el("span", "sp-dot");
		if (o.c) dot.dataset.c = String(o.i);
		dot.setAttribute("aria-hidden", "true");
		lab.append(r, dot, el("span", "", o.label));
		fs.append(lab);
	}
	colorRow.append(fs);
	root.append(colorRow);

	const fid = "sp-flair-" + ++seq;
	const flairRow = el("div", "rv-row");
	const ft = el("div", "rv-row-text");
	const fl = el("label", "rv-row-label", T.flair);
	fl.htmlFor = fid;
	ft.append(fl);
	const sel = el("select", "rv-select");
	sel.id = fid;
	for (const [v, label] of [["", T.noFlair], ...Object.entries(FLAIRS)]) { const o = el("option", "", label); o.value = v; sel.append(o); }
	sel.value = p.flair || "";
	sel.addEventListener("change", () => put({ flair: sel.value }));
	const fc = el("div", "rv-row-control");
	fc.append(sel);
	flairRow.append(ft, fc);
	root.append(flairRow);

	if (state.tier === "patron" || state.founding) root.append(switchRow(T.credits, "", p.credits, (v) => put({ credits: v })));
	// The "Remind me before my pass ends" switch (T.remind) comes back with the start-page card
	// it promises; the server already keeps the choice.
}
